import React, { useMemo, Suspense } from 'react';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Preloader } from '#component/preloader';
import DeviceEvents from '#component/device/overview/events';
import Timeline from '#component/shipment/overview/shipment-timeline/timeline';
import ShipmentInfo from '#component/shipment/overview/shipment-timeline/shipment-info';
import { DialogAppBar, StyledCloseIcon, EventsWrapper } from './styles';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
const TIMELINE_TAB = 110;
const MAP_TAB = 90;
const EVENTS_TAB = 100;
const INFO_TAB = 120;

function DialogWithMeasurements(props) {
  const {
    DeviceMeasurements,
    selectedDevices,
    rangeInterval,
    MapComponent,
    parentState,
    handleClose,
    identifiers,
    isAppliance,
    rangeStart,
    rangeEnd,
    setChart,
    history,
    account,
    shipment,
    events,
    match,
    open,
    tab,
    setClickedEvents,
    syncSelectedDevicesWithStore
  } = props;

  const identifier = identifiers[tab];
  const memoEvents = useMemo(() => [...events], [events]);

  const getDialogTitle = () => {
    switch (tab) {
      case TIMELINE_TAB: {
        return 'TIMELINE';
      }
      case MAP_TAB: {
        return 'MAP';
      }
      case EVENTS_TAB: {
        return 'EVENTS';
      }
      case INFO_TAB: {
        return 'INFO';
      }
      default:
        return identifier?.toUpperCase();
    }
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
      style={{ paddingTop: 56 }}
    >
      <DialogAppBar>
        <Toolbar>
          <StyledCloseIcon
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={handleClose}
          >
            <CloseIcon />
          </StyledCloseIcon>
          <Typography variant="h5">
            {getDialogTitle()}
          </Typography>
        </Toolbar>
      </DialogAppBar>
      {tab === INFO_TAB && (
        <ShipmentInfo shipment={shipment} />
      )}
      {tab === EVENTS_TAB && (
        <EventsWrapper>
          <DeviceEvents
            events={memoEvents}
            history={history}
            account={account}
            syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
          />
        </EventsWrapper>
      )}
      {identifier && (parentState[`${identifier}Loading`] === false ? (
        <Suspense fallback={<Preloader />}>
          <DeviceMeasurements
            selectedDevices={selectedDevices}
            events={events}
            range={{
              rangeStart,
              rangeEnd,
              rangeInterval
            }}
            setChart={setChart}
            match={match}
            identifier={identifiers[tab]}
            isMobile
            isAppliance={isAppliance}
            clickEvents={setClickedEvents}
          />
        </Suspense>
      ) : (
        <Preloader />
      ))}
      {tab === MAP_TAB && MapComponent}
      {tab === TIMELINE_TAB &&
        <Timeline
          account={account}
          delivery={shipment?.delivery}
          shipment={shipment}
        />}
    </Dialog>

  );
}

export default DialogWithMeasurements;
